module.exports = __webpack_public_path__ + "media/images/version_merge/photostep_trash/like_this_cmnd_back-7e3ce8a38dd6499bfe3e83cbbbd2cd05.jpg";